import { startCase, toLower } from 'lodash';
import { isFalsy } from '../../../utils/common';
var getLocationLabel = function (country, city) {
    if (!city && !country)
        return '';
    if (city && !country)
        return city;
    if (country && !city)
        return country;
    return "".concat(city, ", ").concat(country);
};
var getCopyTemplateForCourseDetails = function (course, cspName) {
    var _a, _b, _c, _d, _e, _f, _g;
    var groupedIntakes = (Array.isArray(course === null || course === void 0 ? void 0 : course.openIntakes) &&
        ((_a = course === null || course === void 0 ? void 0 : course.openIntakes) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, item) {
            if (acc[item.status]) {
                acc[item.status].push(item);
            }
            else {
                acc[item.status] = [item];
            }
            return acc;
        }, {}))) ||
        {};
    var applicationFeeLabel = function () {
        var _a;
        if (((_a = course === null || course === void 0 ? void 0 : course.applicationFee) === null || _a === void 0 ? void 0 : _a.toString()) === '0')
            return '💰 No Application Fee';
        if (!isFalsy(course === null || course === void 0 ? void 0 : course.applicationFee) && !isFalsy(course === null || course === void 0 ? void 0 : course.currencyCode)) {
            return "\uD83D\uDCB0 Application Fee: ".concat(course === null || course === void 0 ? void 0 : course.currencyCode, " ").concat(course === null || course === void 0 ? void 0 : course.applicationFee);
        }
        return null;
    };
    var tuitionFeeLabel = function () {
        var _a;
        if (!isFalsy(course === null || course === void 0 ? void 0 : course.tuitionFee) && ((_a = course === null || course === void 0 ? void 0 : course.tuitionFee) === null || _a === void 0 ? void 0 : _a.toString()) !== '0') {
            return "\uD83D\uDCB5 Overall Tuition Fee : ".concat(course === null || course === void 0 ? void 0 : course.currencyCode, " ").concat(course === null || course === void 0 ? void 0 : course.tuitionFee);
        }
        return null;
    };
    var startCaseToLower = function (text) {
        return startCase(toLower(text));
    };
    var intakesLabel = function () {
        var openIntakes = groupedIntakes === null || groupedIntakes === void 0 ? void 0 : groupedIntakes.OPEN;
        if (!isFalsy(openIntakes)) {
            return "Program is offered in: ".concat(openIntakes
                .map(function (i) { return startCaseToLower((i === null || i === void 0 ? void 0 : i.month) + ' ' + (i === null || i === void 0 ? void 0 : i.year)); })
                .join(', '));
        }
        return null;
    };
    var usps = (_c = (_b = course === null || course === void 0 ? void 0 : course.universityUsps) === null || _b === void 0 ? void 0 : _b.map(function (u) { return u.uspLabel; })) !== null && _c !== void 0 ? _c : [];
    var template = "*\uD83C\uDF93 Program: ".concat((_d = course.name) !== null && _d !== void 0 ? _d : '').concat(' ,', "University Name: ").concat(course.universityName, ", ").concat((_f = (_e = course === null || course === void 0 ? void 0 : course.universityAddress) === null || _e === void 0 ? void 0 : _e.city) !== null && _f !== void 0 ? _f : '', ", ").concat((_g = course === null || course === void 0 ? void 0 : course.universityAddress) === null || _g === void 0 ? void 0 : _g.country, "*\n\n").concat(applicationFeeLabel() ? "".concat(applicationFeeLabel(), "\n") : '').concat(tuitionFeeLabel() ? tuitionFeeLabel() : '', "\n").concat(isFalsy(course === null || course === void 0 ? void 0 : course.courseDurationInMonths) ? '' : "\uD83D\uDDD3\uFE0F Course duration: ".concat(course.courseDurationInMonths, " Months \n")).concat(!isFalsy(usps) ? "\n Why choose this course: \n".concat(usps.map(function (u) { return "\uD83C\uDF1F ".concat(u); }).join('\n'), "\n") : '').concat(intakesLabel() ? "\n".concat(intakesLabel(), "\n") : '').concat(isFalsy(intakesLabel()) || isFalsy(usps) ? '\n' : '', "Best Regards,\n").concat(cspName !== null && cspName !== void 0 ? cspName : '', "\n  ");
    return template;
};
var getCopyTemplate = function (course, cspName, studentName) {
    var _a, _b, _c, _d, _e;
    var groupedIntakes = (Array.isArray(course === null || course === void 0 ? void 0 : course.intakes) &&
        ((_a = course === null || course === void 0 ? void 0 : course.intakes) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, item) {
            if (acc[item.status]) {
                acc[item.status].push(item);
            }
            else {
                acc[item.status] = [item];
            }
            return acc;
        }, {}))) ||
        {};
    var applicationFeeLabel = function () {
        var _a;
        if (((_a = course === null || course === void 0 ? void 0 : course.applicationFee) === null || _a === void 0 ? void 0 : _a.toString()) === '0')
            return '💰 No Application Fee';
        if (!isFalsy(course === null || course === void 0 ? void 0 : course.applicationFee) && !isFalsy(course === null || course === void 0 ? void 0 : course.tuitionFeeCurrencyCode)) {
            return "\uD83D\uDCB0 Application Fee: ".concat(course === null || course === void 0 ? void 0 : course.tuitionFeeCurrencyCode, " ").concat(course === null || course === void 0 ? void 0 : course.applicationFee);
        }
        return null;
    };
    var tuitionFeeLabel = function () {
        var _a;
        if (!isFalsy(course === null || course === void 0 ? void 0 : course.tuitionFeeOverall) && ((_a = course === null || course === void 0 ? void 0 : course.tuitionFeeOverall) === null || _a === void 0 ? void 0 : _a.toString()) !== '0') {
            return "\uD83D\uDCB5 Overall Tuition Fee : ".concat(course === null || course === void 0 ? void 0 : course.tuitionFeeCurrencyCode, " ").concat(course === null || course === void 0 ? void 0 : course.tuitionFeeOverall);
        }
        else if (!isFalsy(course === null || course === void 0 ? void 0 : course.tuitionFeePerYear) && (course === null || course === void 0 ? void 0 : course.tuitionFeePerYear) !== 0) {
            return "\uD83D\uDCB5 Tuition Fee First Year: ".concat(course === null || course === void 0 ? void 0 : course.tuitionFeeCurrencyCode, " ").concat(course === null || course === void 0 ? void 0 : course.tuitionFeePerYear);
        }
        return null;
    };
    var intakesLabel = function () {
        var openIntakes = groupedIntakes === null || groupedIntakes === void 0 ? void 0 : groupedIntakes.OPEN;
        if (!isFalsy(openIntakes)) {
            return "Program is offered in: ".concat(openIntakes
                .map(function (i) { return startCaseToLower((i === null || i === void 0 ? void 0 : i.month) + ' ' + (i === null || i === void 0 ? void 0 : i.year)); })
                .join(', '));
        }
        else if (!isFalsy(course === null || course === void 0 ? void 0 : course.intakeMonth)) {
            return "Program is offered in: ".concat(course === null || course === void 0 ? void 0 : course.intakeMonth);
        }
        return null;
    };
    var startCaseToLower = function (text) {
        return startCase(toLower(text));
    };
    var usps = (_c = (_b = course === null || course === void 0 ? void 0 : course.universityUsps) === null || _b === void 0 ? void 0 : _b.map(function (u) { return u.uspLabel; })) !== null && _c !== void 0 ? _c : [];
    var template = "".concat(studentName ? "Hi ".concat(studentName, ",\n\n") : '', "*\uD83C\uDF93 Program: ").concat((_d = course.courseName) !== null && _d !== void 0 ? _d : '').concat(' ,', "University Name: ").concat(course.universityName, ", ").concat((_e = course === null || course === void 0 ? void 0 : course.cityName) !== null && _e !== void 0 ? _e : '', ", ").concat(course === null || course === void 0 ? void 0 : course.countryName, "*\n\n").concat(applicationFeeLabel() ? "".concat(applicationFeeLabel(), "\n") : '').concat(tuitionFeeLabel() ? tuitionFeeLabel() : '', "\n").concat(isFalsy(course === null || course === void 0 ? void 0 : course.duration) ? '' : "\uD83D\uDDD3\uFE0F Course duration: ".concat(course.duration, " Months \n")).concat(!isFalsy(usps) ? "\n Why choose this course: \n".concat(usps.map(function (u) { return "\uD83C\uDF1F ".concat(u); }).join('\n'), "\n") : '').concat(intakesLabel() ? "\n".concat(intakesLabel(), "\n") : '').concat(isFalsy(intakesLabel()) || isFalsy(usps) ? '\n' : '', "Best Regards,\n").concat(cspName !== null && cspName !== void 0 ? cspName : '', "\n  ");
    return template;
};
var copyDetails = function (setIsActive, userDetails, course, studentName, onCopySuccess) {
    setIsActive(true);
    var template = getCopyTemplate(course, userDetails === null || userDetails === void 0 ? void 0 : userDetails.partnerName, studentName);
    var clipboardItem = new ClipboardItem({
        'text/plain': new Blob([template], { type: 'text/plain' })
    });
    onCopySuccess === null || onCopySuccess === void 0 ? void 0 : onCopySuccess();
    void navigator.clipboard.write([clipboardItem]);
    // enqueueSnackbar(`Course Details copied`, { variant: `info` });
    setTimeout(function () {
        setIsActive(false);
    }, 800);
};
var copyDetailsForCourseDetails = function (setIsActive, userDetails, course, onCopySuccess) {
    setIsActive(true);
    var template = getCopyTemplateForCourseDetails(course, userDetails === null || userDetails === void 0 ? void 0 : userDetails.partnerName);
    var clipboardItem = new ClipboardItem({
        'text/plain': new Blob([template], { type: 'text/plain' })
    });
    onCopySuccess === null || onCopySuccess === void 0 ? void 0 : onCopySuccess();
    void navigator.clipboard.write([clipboardItem]);
    // enqueueSnackbar(`Course Details copied`, { variant: `info` });
    setTimeout(function () {
        setIsActive(false);
    }, 800);
};
export { getLocationLabel, copyDetails, copyDetailsForCourseDetails };
//# sourceMappingURL=CfCourseCardUtil.js.map